import type { Component } from 'solid-js'
import Card from '~/components/Card'
import Icon from '~/components/Icon'
import type { CustomerType } from '~/services/customer.service'

interface TabResumenProps {
  data: CustomerType
}

const TabResumen: Component<TabResumenProps> = props => {
  return (
    <>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
        <Card>
          <Card.Body>
            <div class="flex items-center justify-between">
              <div>
                <p class="text-xs text-foreground-subtle">Saldo actual</p>
                <p class="text-xl font-bold text-foreground">${Number(props.data.saldoActual ?? 0).toLocaleString('es-CO')}</p>
              </div>
              <Icon icon="material-symbols-light:account-balance-wallet-outline" size={28} class="text-foreground-subtle" />
            </div>
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <div class="flex items-center justify-between">
              <div>
                <p class="text-xs text-foreground-subtle">Saldo vencido</p>
                <p class="text-xl font-bold text-danger">${Number(props.data.saldoVencido ?? 0).toLocaleString('es-CO')}</p>
              </div>
              <Icon icon="material-symbols-light:warning-outline" size={28} class="text-danger" />
            </div>
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <div class="flex items-center justify-between">
              <div>
                <p class="text-xs text-foreground-subtle">Total compras</p>
                <p class="text-xl font-bold text-foreground">${Number(props.data.totalCompras ?? 0).toLocaleString('es-CO')}</p>
              </div>
              <Icon icon="material-symbols-light:savings-outline" size={28} class="text-success" />
            </div>
          </Card.Body>
        </Card>
      </div>

      <Card>
        <Card.Header>Resumen del cliente</Card.Header>
        <Card.Body>
          <dl class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
            <div>
              <dt class="text-foreground-subtle text-xs">Tipo de persona</dt>
              <dd class="font-medium text-foreground">{props.data.tipoPersona === 'juridica' ? 'Jurídica' : 'Natural'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Tipo de documento</dt>
              <dd class="font-medium text-foreground">{props.data.documentType || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Documento</dt>
              <dd class="font-medium text-foreground">{props.data.document || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Teléfono</dt>
              <dd class="font-medium text-foreground">{props.data.phone || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Celular</dt>
              <dd class="font-medium text-foreground">{props.data.celular || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Correo</dt>
              <dd class="font-medium text-foreground truncate">{props.data.email || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Ciudad</dt>
              <dd class="font-medium text-foreground">{props.data.ciudad || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Cupo de crédito</dt>
              <dd class="font-medium text-foreground">${Number(props.data.cupoCredito ?? 0).toLocaleString('es-CO')}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Días de crédito</dt>
              <dd class="font-medium text-foreground">{props.data.diasCredito ?? 0} días</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Clasificación</dt>
              <dd class="font-medium text-foreground">{props.data.clasificacion || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Origen</dt>
              <dd class="font-medium text-foreground">{props.data.origenCliente || '—'}</dd>
            </div>
            <div>
              <dt class="text-foreground-subtle text-xs">Creado</dt>
              <dd class="font-medium text-foreground">{new Date(props.data.createdAt).toLocaleDateString('es-CO')}</dd>
            </div>
          </dl>
        </Card.Body>
      </Card>
    </>
  )
}

export default TabResumen
